module.exports = __webpack_public_path__ + "static/media/userpp-hero.c6e6ff25.svg";